import React, { ReactElement, useEffect } from 'react';
import { useDataCollection } from '../../../../../hooks';
import CheckCard from '../../../../components/Form/CheckCard';
import { InjectedWizardStepProps } from '../../../../components/Steps/WizardStep';
import StepHeader from '../../../../components/Layout/StepHeader';
import {
    houseFloorPlaneRectangularShapeOptions,
    houseFloorPlaneShapeOptions,
    houseFloorPlaneLShapeOptions,
    houseFloorPlaneUShapeOptions,
    houseFloorPlaneTShapeOptions,
} from '../../../../../data/enumerations';
import { Form } from 'formik';

const StepHouseFloorPlaneShapeDetail = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();
    const selectedFloorPlanShape = houseFloorPlaneShapeOptions.find((option) => option.value === values.floorPlanShape);

    let shapeDetailOptions;
    let shapeDetailTitleSecondOptions;

    switch (values.floorPlanShape) {
        case 'RECTANGULAR':
            shapeDetailOptions = houseFloorPlaneRectangularShapeOptions;
            shapeDetailTitleSecondOptions = 'Jaký tvar "Čtverce/obdélníku" nejlépe odpovídá?';
            break;
        case 'L_SHAPE':
            shapeDetailOptions = houseFloorPlaneLShapeOptions;
            shapeDetailTitleSecondOptions = 'Jaký tvar "Elka" nejlépe odpovídá?';
            break;
        case 'U_SHAPE':
            shapeDetailOptions = houseFloorPlaneUShapeOptions;
            shapeDetailTitleSecondOptions = 'Jaký tvar "Účka" nejlépe odpovídá?';
            break;
        case 'T_SHAPE':
            shapeDetailOptions = houseFloorPlaneTShapeOptions;
            shapeDetailTitleSecondOptions = 'Jaký tvar "Téčka" nejlépe odpovídá?';
            break;

        default:
            break;
    }

    useEffect(() => {
        if (values.groundPlanType) {
            completeStep && completeStep(true);
        }
    }, [values]);

    return (
        <Form>
            <StepHeader title="Upřesnění půdorysu" />
            <div>
                <div className={'wiz-card wiz-card--small'}>
                    <div className={'wiz-card__inner wiz-card__inner--specification'}>
                        {selectedFloorPlanShape && (
                            <div className={'wiz-card-item'}>
                                <CheckCard
                                    name={'floorInsulation'}
                                    onChange={handleChange}
                                    checked={true}
                                    value={selectedFloorPlanShape.value}
                                    img={selectedFloorPlanShape.img}
                                    //title={selectedFloorPlanShape.title}
                                    titleSecond = {shapeDetailTitleSecondOptions}
                                    description={selectedFloorPlanShape.description}
                                />
                            </div>
                        )}

                        {shapeDetailOptions &&
                            shapeDetailOptions.map((option) => {
                                return (
                                    <div key={option.value} className={'wiz-card-item'}>
                                        <CheckCard
                                            name={'groundPlanType'}
                                            onChange={handleChange}
                                            checked={values.groundPlanType === option.value}
                                            value={option.value}
                                            img={option.img}
                                            title={option.title}
                                        />
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default StepHouseFloorPlaneShapeDetail;
